import styled from "styled-components";
import {
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
} from "@mui/material";
import { deviceSpec } from "breakpoints";

export const StyledHeader = styled.header`
  border-bottom: ${({ theme }) => theme.borders.headerBorder};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  height: 65px;
  box-shadow: 0 0 14px 1px rgba(255, 255, 255, 0.1);

  background-color: ${({ theme }) => theme.colors.dark};
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;

  padding: 1rem;
  display: flex;

  box-shadow: 0px 2px 1px -1px rgba(64, 64, 64, 0.6),
    0px 1px 1px 0px rgba(128, 128, 128, 0.3),
    0px 1px 3px 0px rgba(192, 192, 192, 0.1),
    0px 1px 5px 0px rgba(192, 192, 192, 0.05);

  .header-button-and-logo {
    display: flex;

    .hamburger-icon {
      align-self: end;
      padding: 8px;

      svg {
        stroke: ${({ theme }) => theme.colors.white};
      }
    }

    .company-logo {
      margin-left: 0.5rem;
      align-self: end;
    }
  }
`;

export const DrawerTitle = styled("p")`
  font-size: ${({ theme }) => theme.font.h3};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textColor};
  margin: 0;
`;

export const CustomIconButton = styled(IconButton)`
  svg {
    width: 28px;
    height: 28px;
    transition: transform 0.2s ease;
  }

  svg {
    stroke: transparent !important;
  }

  &:hover svg {
    transform: scale(1.1);
  }
`;

export const CustomListItemIcon = styled("div")`
  vertical-align: text-bottom;
  display: grid;
`;

export const SideBarCollapsedItems = styled("div")`
  margin: 0.5rem 0 0.5rem 1.25rem;
  border-left: 1px solid rgba(0, 0, 0, 0.15);
`;

export const SidebarItemContainer = styled.div<{
  ismenuitemactive: string;
  isDrawerOpen: boolean;
}>`    
  width: ${({ isDrawerOpen }) => (isDrawerOpen ? "100vw" : "")};

  svg {
    stroke: white;
  }

  // Manage Menu Item
  .sidebar-parent-text-container {
    padding: 0.6rem 0.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: ${({ isDrawerOpen }) =>
      isDrawerOpen ? "flex-start" : "center"};
    border-radius: ${({ theme }) => theme.borders.borderRadius};
    transition: background-color 0.2s ease, transform 0.1s ease;

    p, a, .MuiTypography-root {
      transition: color 0.3s ease;
    }
    
    svg {
      transition: stroke 0.3s ease, color 0.3s ease;
    }

    .sidebar-text:nth-child(2) rounded w-full color-white px-2 {
      flex-grow: 1;
    }

    .sidebar-text:nth-child(2) {
      max-width: ${({ isDrawerOpen }) => (isDrawerOpen ? "auto" : "0px")};
      transition: max-width 0.3s ease-in-out, opacity 0.2s ease, color 0.3s ease;
      opacity: ${({ isDrawerOpen }) => (isDrawerOpen ? 1 : 0)};
      color: ${({ theme }) => theme.colors.textColor};
    }
  }

  // Manage Menu item selection
  background-color: ${({ theme, ismenuitemactive, isDrawerOpen }) =>
    (ismenuitemactive === "true" && isDrawerOpen &&  theme.name === "light-theme") && "rgb(229, 209, 255) !important"};
  background-color: ${({ theme, ismenuitemactive, isDrawerOpen }) =>
    (ismenuitemactive === "true" && isDrawerOpen &&  theme.name === "dark-theme") && "#272c39 !important"};
      
  border-radius: ${({ theme, ismenuitemactive }) =>
    ismenuitemactive === "true" ? "8px" : ""};
  margin: ${({ theme, ismenuitemactive }) =>
    ismenuitemactive === "true" ? "0.35rem 0.2rem" : ""};

  transition: background-color 0.3s ease, border-radius 0.3s ease, margin 0.3s ease;

  .sidebar-parent-text-container:hover,
  .sidebar-parent-text-container:active {
    width: "16vw";

    background-color: ${({ theme }) => theme.name === "light-theme"
        ? "rgb(229, 209, 255) !important"
        : "#272c39 !important"
    };
        
    transform: translateX(2px);
    
    p, a, .MuiTypography-root {
      transition: color 0.3s ease;
    }
    
    svg {
      transition: stroke 0.3s ease, color 0.3s ease;
    }
  }
`;

export const TooltipChildrenContainer = styled("span")`
  padding: 0.75rem;
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.dark};
  border-radius: ${({ theme }) => theme.borders.borderRadius};
  border-radius: ${({ theme }) => theme.shadows.button};

  max-height: 300px;
  display: flex;
  flex-wrap: wrap;
  max-width: max-content;
  flex-direction: column;

  .hover-color {
    padding: 0.5rem !important;
    display: flex;
    padding: 1rem;
    width: max-content;
    border-radius: ${({ theme }) => theme.borders.borderRadius};
    cursor: pointer;
    padding: 0 1.45rem;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.textColor};
  }

  .hover-color:hover {
    background-color: ${({ theme }) => theme.colors.light};
  }
`;

export const TooltipItem = styled("div")``;

export const SidebarItemContainerCollapse = styled(Collapse)`
  background-color: ${({ theme }) => theme.colors.dark};
`;

export const CustomListItemContainer = styled(ListItem).withConfig({
  shouldForwardProp: (prop) => prop !== "showexpandedmenu",
})<{ showexpandedmenu: boolean }>`
  border-radius: ${({ theme }) => theme.borders.borderRadius};
  padding: 0 !important;

  display: ${({ showexpandedmenu }) =>
    showexpandedmenu ? "flex !important" : "none !important"};

  p {
    padding: 0 0.5em;
  }
  .MuiTypography-root {
    margin-left: 0 !important;
    a {
      text-decoration: none;
    }
    p {
      margin-left: 0 !important;
    }
  }
`;

export const NavLogo = styled("img")`
  height: 32px;
`;

export const CustomDrawer = styled(Drawer)<{ open: string }>`
  transition: width 0.3s ease-in-out;
  width: ${(props) => (props.open === "true" ? "300px" : "65px")};
  height: 100%;
  background-color: ${({ theme }) => theme.colors.sidebarcolor} !important;

  .MuiDrawer-paper {
    position: relative !important;
    border: none;
    border-right: none !important;
    width: ${(props) => (props.open === "true" ? "300px" : "65px")};
    overflow: hidden;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
    z-index: 1;
    background-color: ${({ theme, open }) =>
      open === "true"
        ? theme.colors.sidebaropen
        : theme.colors.sidebarcolor} !important;
    transition: width 0.3s ease-in-out, background-color 0.3s ease;
  }

  /* For the Nav Item's text */
  .MuiTypography-root {
    margin-left: 0.5rem;
  }

  .MuiTooltip-tooltip {
    font-size: 1rem !important;
    background-color: ${({ theme }) => theme.colors.dark} !important;
    color: ${({ theme }) => theme.colors.textColor} !important;
  }

  .mobile {
    height: 100%;
    background-color: ${({ theme }) => theme.colors.dark};
  }

  .mobile-header {
    height: 65px;
    padding: 1rem;
  }
`;

export const FavoritesContainer = styled("div")<{ active?: boolean; isDrawerOpen?: boolean }>`
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: background-color 0.2s ease, transform 0.1s ease;
  width: ${({ isDrawerOpen }) => isDrawerOpen ? "200%" : "100%"};

  span {
    display: flex;
    align-items: center;

    p {
      font-size: ${({ theme }) => theme.font.large};
      margin-left: 0.75rem;
      font-weight: 500;
      color: ${({ active, theme }) => active ? theme.name === "dark-theme" ? "#A100FF" : theme.colors.textColor : "white"};
    }
    
    svg {
      stroke: white !important;
      color: transparent !important;
    }
  }
  
  /* Apply selected styling when active */
  background-color: ${({ active, theme }) => 
    active && theme.name === "dark-theme" && "#272c39"};

  /* Active state styling */
  ${({ active, theme }) =>
    active && theme.name === "dark-theme"
      && `
    span p,
    span svg {
      color: ${theme.colors.white} !important;
      stroke: ${theme.colors.white} !important;
      transition: color 0.3s ease, stroke 0.3s ease;
    }
    `}
    
  ${({ active, theme }) =>
    active && theme.name === "light-theme"
      && `
    span p {
      color: ${theme.colors.textColor} !important;
      transition: color 0.3s ease;
    }
    
    span svg {
      stroke: ${theme.colors.textColor} !important;
      transition: stroke 0.3s ease;
    }
    `}

  background-color: ${({ active, theme }) => 
    active && theme.name === "light-theme" && "rgb(229, 209, 255) !important"};
  
  border-radius: ${({ active }) => active ? "8px" : ""};
  margin: ${({ active }) => active ? "0.35rem 0.2rem" : ""};

  &:hover {
    /* No background on hover */
    transform: translateX(2px);
    background-color: ${({ theme }) => theme.name === "light-theme"
        ? "rgb(229, 209, 255) !important"
        : "#272c39 !important"
    };

    p, span p {
      color: ${({ theme }) => theme.name === "light-theme" ? theme.colors.textColor : theme.colors.white} !important;
      transition: color 0.3s ease;
    }
    
    svg, span svg {
      stroke: ${({ theme }) => theme.name === "light-theme" ? theme.colors.textColor : theme.colors.white} !important;
      transition: stroke 0.3s ease;
    }
  }
`;

export const FavoritesNumber = styled("span")`
  background-color: hsl(0deg 0% 0% / 0.05) !important;
  color: ${({ theme }) => theme.colors.white} !important;
  width: 24px;
  height: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  font-weight: 600;
  font-size: 0.85rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  }
`;

export const CustomDrawerHeader = styled("div")<{ isDrawerOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 58px;
  padding: 0 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid
    ${({ theme }) =>
      `${theme.colors.lightGreyRgba || "rgba(85, 85, 85, .4)"}20`};

  svg {
    stroke: ${({ theme, isDrawerOpen }) => isDrawerOpen ? theme.colors.white : 'transparent'};
  }

  p {
    color: white;
  }
`;

export const SidebarContainerLayout = styled("div")`
  display: flex;
  flex-direction: row;
  // overflow-y: scroll;
  // height: calc(100vh - 58px);
`;

export const SidebarDataLayout = styled("div")`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.dark};
  z-index: 6;

  p, a, .MuiTypography-root {
    color: ${({ theme }) => theme.colors.white};
    font-weight: 500;
  }
  
  svg {
    stroke: ${({ theme }) => theme.colors.white};
  }

  .sidebar-parent-text-container:hover, .side-item-selected {
    p, a, .MuiTypography-root {
      color: ${({ theme }) => theme.colors.textColor};
    }
  
    svg {
      stroke: ${({ theme }) => theme.colors.textColor};
    }
  }
  
  .MuiButtonBase-root {
    width: fit-content;
    min-width: fit-content;
    padding: 6px 8px;
  }

  .MuiFormControl-root {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 1rem;
  }

  .vertical-border-lines {
    border-left: 1px solid rgba(0, 0, 0, 0.15);
  }

  .show-tablet {
    display: none;
  }

  @media ${deviceSpec.isLaptop} {
    .show-tablet {
      display: initial;
    }
  }
`;

export const SideBarMenuContainer = styled("div")`
  padding: 0.5rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SidebarSearchContainer = styled("div")`
  display: flex;
  position: sticky;
  top: 58px;
  z-index: 5;
  padding-bottom: 0.5rem;

  svg,
  p,
  input {
    color: white;
    stroke: white;
  }
`;

export const SidebarItemsContainer = styled("div")<{ isDrawerOpen: boolean }>`
  overflow: hidden;
  background-color: ${({ theme, isDrawerOpen }) =>
    isDrawerOpen ? theme.colors.sidebaropen : theme.colors.sidebarcolor};
  white-space: nowrap;
  height: auto;

  > div:nth-child(1) {
    box-shadow: -21px 10px 10rem 2.5rem rgba(255, 255, 255, 0.015);
  }

  /* This style is now defined directly in the FavoritesContainer component */

  h3 {
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 0.05rem;
    color: ${({ theme }) =>
      theme.colors.textDisabledColor || "rgba(255,255,255,0.6)"};
    margin: 0;
    padding: 0.5rem 0;
  }
`;

export const SidebarItemsList = styled(List)`
  background-color: ${({ theme }) => theme.colors.dark};

  div {
    height: 100%;
  }
`;

export const DrawerHeaderSticky = styled("div")<{ isDrawerOpen: boolean }>`
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: ${({ theme, isDrawerOpen }) =>
    isDrawerOpen ? theme.colors.sidebaropen : theme.colors.sidebarcolor};
`;

export const SidebarChatRow = styled("div")<{ active?: boolean }>`
  margin: 4px 0;
  padding: 8px 12px;
  border-radius: 8px;
  transition: background-color 0.2s ease, transform 0.1s ease;
  width: 200%;
  
  &:hover {
    background-color: ${({ theme }) => theme.name === "light-theme"
      ? "rgb(229, 209, 255) !important"
      : "#272c39 !important"
    };
    span {
      color: ${({ theme }) => theme.colors.textColor} !important;
    }
  }
`;

export const CategoryHeader = styled("div")`
  &.category-header {
    width: 200%;
    
    &:hover {
      background-color: ${({ theme }) => theme.name === "light-theme"
        ? "rgb(229, 209, 255) !important"
        : "#272c39 !important"
      };
      
      p, div {
        color: ${({ theme }) => theme.colors.textColor} !important;
      }
    }
  }
`;